import React from 'react';
import MainLayout from '../layouts/MainLayout';
import '../styles/ComingSoon.css';
import comingsoonimage from '../assets/pageimages/ComingSoon.webp';

export default function ComingSoon() {

  return (
    <MainLayout>
      <div className='mt-12'>
        <div className="ml-2 mr-0 border border-b-gray-300 bg-gray-800">
          <div className='flex text-lg my-4 py-4 mx-8 text-white'>
            <p className='text-yellow-200 text-lg'>
              <span role="img" aria-label="rocket" className='text-6xl flex justify-center'>🚀</span><br/> Exciting News! Something Amazing Is On Its Way.
              <br /><br />
              Dear User,
              <br /><br />
              We are thrilled to share that something extraordinary is in the works! Our team has been working tirelessly to bring you an innovative and game-changing experience that will redefine the deep think & a critical analysis for anything around you and make life easier, predictble, more manageable, qualittaive, productive and so on.
              <br /><br />
              <span role="img" aria-label="calendar">🗓️</span> Countdown:
              The excitement is building, and we can't wait to unveil it. Join us on this thrilling journey as we count down the days until the big reveal.
              <br /><br />
              <span role="img" aria-label="email">📧</span> Stay Connected:
              Want to be the first to know when we launch? Subscribe to our newsletter and be part of an exclusive group that gets early access and exciting updates.
              <br /><br />
              <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                Subscribe Now
              </button>
              <br />
              Thank you for your continued support. 
              <br />
              We can't wait to share this moment with you!
              <br />
              Best regards,
              The support@think5whys.com Team
            </p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
  
